import Button from '@mui/material/Button'

import { SnackbarType } from '$/types'
import { useAppDispatch } from 'app/hooks'
import { openWisDetailsModal } from 'app/entities/store/modalsSlice'
import useClickOutside from './useClickOutside'

const message =
  'The current filters do not match the What-If Scenario and the data may not be presented accurately. To ensure accuracy, view the details and update the filters accordingly.'

const SavedStateDontMatchSystemScopeRoutes = ({ onClose }: SnackbarType) => {
  const dispatch = useAppDispatch()

  const snackbarRef = useClickOutside(onClose)

  const openDetails = () => {
    onClose()
    dispatch(openWisDetailsModal())
  }

  const buttonsPanel = [
    {
      text: 'DISMISS',
      action: onClose
    },
    {
      text: 'VIEW DETAILS',
      action: openDetails
    }
  ]

  return (
    <div className='flex rounded bg-black p-2 w-full' ref={snackbarRef}>
      <div className='ml-2 font-light text-white'>{message}</div>
      <div className='flex text-lighthouseBlue'>
        {buttonsPanel.map((button) => (
          <Button key={button.text} onClick={button.action} className='w-max'>
            {button.text}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default SavedStateDontMatchSystemScopeRoutes
